module.exports = __webpack_public_path__ + "img/DCHSummary77-512.4961472d.png";